import React, {lazy, Suspense} from 'react'

const DevotionLazy = lazy(() =>
    import('./Devotion')
)

const Devotion = props => (
    <Suspense fallback={null}>
        <DevotionLazy {...props} />
    </Suspense>
)

export default Devotion
